



import React, { useEffect } from 'react';
import { useRef,useState } from 'react';
import {motion} from 'framer-motion'

// import "../../Components/HeroSection/HeroSection.css"
// import "./CourseCarousel.css"
import img1 from "../../Images/Landing.jpg"
import img2 from "../../Images/Landing.jpg"
import img3 from "../../Images/Landing.jpg"
import img4 from "../../Images/Landing.jpg"
import img5 from "../../Images/Landing.jpg"
import img6 from "../../Images/Landing.jpg"
import img7 from "../../Images/Landing.jpg"


// import React, { useRef } from 'react'
// import {motion} from 'framer-motion'
// export const Box = () => {

function CourseCarousel() { 

    const boxRef = useRef(null)
  return (
    <div
        style={{
            height: '300px',
            padding: '10px',
            border: '1px solid black',
            display: 'flex',
            width: '25%',
            overflowX: 'hidden',
        }}
        ref={boxRef}
    >
        <motion.div
            style={{
                height: '50px',
                padding: '10px',
                border: '1px solid black',
                display: 'inline-flex',
                gap: '10px',
            }}
            drag='x'
            dragConstraints={boxRef}
        >
            {
                Array.from({length: 20}).map((_, i) => (
                    <div
                        key={i}
                        style={{
                            minWidth: '50px',
                            height: '50px',
                            backgroundColor: 'red',
                        }}
                    />
                ))
            }
        </motion.div>
    </div>
  )
}

export default CourseCarousel;





// function CourseCarousel() { 

//     const [width, setWidth] = useState(0)

//     const carousel = useRef()

//     const images = [
//         {imageUrl : img1},
//         {imageUrl : img2},
//         {imageUrl : img3},
//         {imageUrl : img4},
//         {imageUrl : img5},
//         {imageUrl : img6},
//         {imageUrl : img7},
//     ]
 
//     useEffect(()=>{
//         console.log("caroua",carousel.current.scrollWidth)
//     },[])

//   return <>
//         <div className='CourseCarouselCover'>   


//                 <motion.div ref={carousel} className='carousel'>      

//                         <motion.div

//                                 drag='x'
//                                         dragConstraints={{
//                                            right : 0,
                                      
                                           
//                                         }} 
                        
//                          className='InnerCarousel'>    

//                                 {images.map((item,index)=>{
//                                     return(
//                                         <motion.div 

                                    
                                        
                                        
//                                         className='item' key={index}> 
//                                                 <img src={item.imageUrl} />
//                                         </motion.div>
//                                     )
//                                 })}

//                         </motion.div>
            

//                 </motion.div>
            
        

//         </div>
       
    
//   </>
  
//   ;
// }

// export default CourseCarousel;


